import { useGlobalState } from '@/hooks';
import { AccountVerificationWrapper } from './AccountVerification.styles';

const AccountVerification: React.FC = () => {
  const { userInfo } = useGlobalState();
  return <AccountVerificationWrapper>{userInfo?.email}</AccountVerificationWrapper>;
};

export default AccountVerification;
